export default [
  {
    path: '/signup',
    name: 'signup',
    component: () => import(/* webpackChunkName: "signup" */ '../../views/signup/SignUp')
  }
]
